import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Work from "../../entity/user/Work";

const SERVICE = "service-user";
const ENTITY = "works";

export default function () {
    const {findAll, findOneBy, create, update} = useApi();
    const state = useSelector;
    const newInstance = data => new Work(data);

    return {
        findOneById(id) {
            return {
                select() {

                    const result = state(state => state.api?.user?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "guest");
                }
            }
        },
        findAll() {
            return {
                select() {

                    const result = state(state => state.api?.user?.[ENTITY]?.filter(w => !isNull(w)));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findAll(SERVICE, ENTITY, newInstance);
                }
            }
        }
    }
}